import { render, staticRenderFns } from "./feedbackMobileView.vue?vue&type=template&id=2223b991&scoped=true"
import script from "./feedbackMobileView.vue?vue&type=script&lang=js"
export * from "./feedbackMobileView.vue?vue&type=script&lang=js"
import style0 from "./feedbackMobileView.vue?vue&type=style&index=0&id=2223b991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2223b991",
  null
  
)

export default component.exports